import { useContext, useEffect, useState } from "react";
import LeftPanelImage from "../microcomponents/LeftPanelImage";
import { ContactLeftPanelItems } from "../../Data/ContactLeftPanelItems";
import ContactLeftPanelMenuItem from "../microcomponents/ContactLeftPanelMenuItem";
import LeftPanelUserDetails from "../microcomponents/LeftPanelUserDetails";
import DarkModeSelection from "../microcomponents/DarkModeSelection";
import SignoutLeftPanel from "../microcomponents/SignoutLeftPanel";
import { Skeleton } from "primereact/skeleton";
import { capitalizeFirstLetter, updatePanelItems } from "app/utils/utils";
import { ContactProfileDetailsContext } from "./ContactLayout";
import LeftPanelBrandingLogo from "../microcomponents/LeftPanelBrandingLogo";
import { getObjectFromSessionStore, setObjectInSessionStore } from "app/utils/sessionStore";
import { makeRequest } from "app/utils/makeRequest";

const ContactLeftPanel = () => {
  const { contactFirstName, contactLastName, isOpen, setIsOpen } = useContext(
    ContactProfileDetailsContext,
  );
  const propStats = getObjectFromSessionStore("proposalStats");
  const [proposalStats, setProposalStats] = useState<any>(propStats ?? {});

  const updateProposalStats = () => {
    makeRequest("proposalStats")
      .get()
      .then((res) => {
        setProposalStats(res.data.data ?? {});
        setObjectInSessionStore("proposalStats", res.data.data ?? {});
      });
  };

  useEffect(() => {
    updateProposalStats();
  }, []);

  const ContactLeftPanelItemsUpdated = updatePanelItems(ContactLeftPanelItems, proposalStats);

  return (
    <div className={`px-1 h-screen relative ${isOpen ? "w-63" : "w-32"}`}>
      <aside className="min-h-[80vh] pt-2 bg-transparent absolute left-2" style={{ top: "-8rem" }}>
        <nav className="h-full flex flex-col bg-light-primary  dark:bg-dark-primary relative border-r border-primary-bg-border border-[1px] shadow-sm-2 rounded-2xl pt-6 pb-4 px-2">
          <div className="absolute right-[-20px] top-2 pb-2 flex justify-between items-center bg-transparent">
            <button
              type="button"
              onClick={() => {
                setIsOpen((prev: any) => !prev);
              }}
              className="flex items-center justify-center rounded-lg dark:bg-dark-primary"
            >
              {isOpen ? (
                <i
                  className="pi pi-angle-double-left p-2 rounded-lg bg-gray-200 dark:!bg-dark-primary dark:border-[1px] dark:border-colorBoder hover:bg-gray-100"
                  style={{ fontSize: "1rem" }}
                />
              ) : (
                <i
                  className="pi pi-angle-double-right  p-2 rounded-lg  bg-gray-200  dark:!bg-dark-primary dark:border-[1px] dark:border-colorBoder hover:bg-gray-100"
                  style={{ fontSize: "1rem" }}
                />
              )}
            </button>
          </div>
          <LeftPanelBrandingLogo isOpen={isOpen} />
          <LeftPanelImage />
          <h4
            className={`text-xl font-semibold text-gray-arrow text-center my-3 transition-opacity  ${
              isOpen ? "opacity-100" : "opacity-0 hidden"
            }`}
          >
            {contactFirstName || contactLastName ? (
              `${capitalizeFirstLetter(contactFirstName)}, ${capitalizeFirstLetter(
                contactLastName,
              )}`
            ) : (
              <Skeleton width="100%" height="3rem" borderRadius="16px" className="mb-2" />
            )}
          </h4>
          <div className="mt-4 mb-6 px-2">
            <div className="w-full h-[1px] bg-gray-500 rounded-md" />
          </div>
          <ul className="flex-1 px-3 mb-3">
            {ContactLeftPanelItemsUpdated.map(
              (item: any) =>
                !item.hide && (
                  <ContactLeftPanelMenuItem
                    key={item.id}
                    directTo={item.key}
                    name={item.name}
                    icon={item.icon}
                  />
                ),
            )}
          </ul>
          <div className="w-full flex  justify-center items-center mt-4">
            <LeftPanelUserDetails />
          </div>
          <DarkModeSelection />
          <SignoutLeftPanel />
        </nav>
      </aside>
    </div>
  );
};

export default ContactLeftPanel;
